export const environment = {
  apiUrl: 'https://dev.zorbek.software/ALDDA/api/',
  alddaMxUrl: 'https://dev.zorbek.software/ALDDA/App/',
  notificationUrl: 'https://localhost:44301/',
  production: true,
  imagesUrl: 'https://dev.zorbek.software/ALDDA/API/Image/',
  baseHref: '/',
  zorbekSepomexApiUrl: 'https://sepomex.zorbek.software/',
  alddaEmbedUrl: 'https://aldda.ld.zorbek.software/embed-client/',
};
